module.exports = __webpack_public_path__ + "media/images/emblems/Montilliez-coat_of_arms-b4d0e5a0deb6a90f607f1710a46a0106.svg";